import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Note } from '../../case/model/note';

@Injectable({
    providedIn: 'root'
})
export class NotesService
{

    constructor(private http: HttpClient) { }

    /**
     * Get all Notes for a Case
     */
    public getCaseNotes(caseId: number): Observable<Note[]>
    {
        return this.http.get<Note[]>(`/notes/case/${caseId}`);
    }

    /**
     * Get all Notes for a Member
     */
    public getMemberNotes(memberId: number): Observable<Note[]>
    {
        return this.http.get<Note[]>(`/notes/member/${memberId}`);
    }

    /**
     * Save a Note.
     *
     * @param note Note to save.
     */
    public saveNote(note: Note, isNew: boolean): Observable<Note>
    {
        if (isNew)
        {
            return this.http.post<Note>('/notes', note);
        }
        else
        {
            return this.http.put<Note>(`/notes/${note.id}`, note);
        }
    }

    /**
     * Get a Note.
     *
     * @param note Note to get.
     */
    public getNoteById(id: number): Observable<any>
    {
        return this.http.get<any>(`/notes/${id}`);
    }

    /**
     * Delete a Note.
     *
     * @param note Note to get.
     */
    public deleteNote(id: number): Observable<any>
    {
        return this.http.delete<any>(`/notes/${id}`);
    }

}
